module.exports = __webpack_public_path__ + "static/feature-team1-d29ac82c963d41bce0624b60fdd59c08.png";